export const getUrlParam = (paramName) => {
  if (typeof window === 'undefined') {
    return null;
  }

  // eslint-disable-next-line no-undef
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(paramName);
};

/**
 * Canonical software_type values stored on FormalQuote and used by the processor.
 * Product slugs (hyphens) and URL params map into these; never persist a slug.
 */
export const SOFTWARE_TYPES = {
  viewmate_essentials: 'viewmate_essentials',
  viewmate_business: 'viewmate_business',
  viewmate_professional: 'viewmate_professional',
  cammaster_designer: 'CAMMaster Designer',
};

export const PRODUCT_SLUG_TO_SOFTWARE_TYPE = {
  'viewmate-essentials': SOFTWARE_TYPES.viewmate_essentials,
  'viewmate-business': SOFTWARE_TYPES.viewmate_business,
  'viewmate-professional': SOFTWARE_TYPES.viewmate_professional,
};

export const SOFTWARE_TYPE_URL_MAP = {
  viewmate_essentials: SOFTWARE_TYPES.viewmate_essentials,
  viewmate_business: SOFTWARE_TYPES.viewmate_business,
  viewmate_professional: SOFTWARE_TYPES.viewmate_professional,
  cammaster_designer: SOFTWARE_TYPES.cammaster_designer,
};

export const mapProductSlugToSoftwareType = (slug) => {
  if (!slug) return null;
  return PRODUCT_SLUG_TO_SOFTWARE_TYPE[slug] || null;
};

export const mapUrlParamToSoftwareType = (urlParam) => {
  if (!urlParam) return null;
  return SOFTWARE_TYPE_URL_MAP[urlParam] || null;
};
